<template>
  <div class="article-sections-feed">
    <ArticleEditorsChoice v-if="editorChoiceSection" :items="editorChoiceSection.items" />

    <ArticleSection
      v-if="apkNewsSection"
      title="Новости АПК"
      :items="apkNewsSection.items"
      show-view-all
      @view-all="$emit('view-all', apkNewsSection.id)"
    />

    <ArticleColoredSection
      v-if="careerSection"
      title="Карьера"
      :items="careerSection.items"
      bg-color="#ffcb10"
      :decorative-image="careerImage"
      @view-all="$emit('view-all', careerSection.id)"
    />

    <ArticleSection
      v-if="educationSection"
      title="Образование и наука"
      :items="educationSection.items"
      show-view-all
      @view-all="$emit('view-all', educationSection.id)"
    />

    <ArticleColoredSection
      v-if="posterSection"
      title="Афиша и конкурсы"
      :items="posterSection.items"
      bg-color="#df97fa"
      :decorative-image="posterImage"
      @view-all="$emit('view-all', posterSection.id)"
    />

    <ArticleSection
      v-if="lifehacksSection"
      title="Лайфхаки"
      :items="lifehacksSection.items"
      show-view-all
      @view-all="$emit('view-all', lifehacksSection.id)"
    />

    <ArticleColoredSection
      v-if="digitalLectureSection"
      title="Цифровой лекторий"
      :items="digitalLectureSection.items"
      bg-color="#66d6fb"
      :decorative-image="digitalLectureImage"
      @view-all="navigateTo('/digital-lecture')"
    />
  </div>
</template>

<script lang="ts" setup>
import ArticleEditorsChoice from './ArticleEditorsChoice.vue'
import ArticleSection from './ArticleSection.vue'
import ArticleColoredSection from './ArticleColoredSection.vue'
import type { ArticleMainSection } from '~/models/articles'
import careerImage from '~/assets/images/pages/articles/piggy-bank.png'
import posterImage from '~/assets/images/pages/articles/star.png'
import digitalLectureImage from '~/assets/images/pages/articles/learn.png'

const props = defineProps<{
  sections: ArticleMainSection[]
}>()

defineEmits<{
  (e: 'view-all', categoryId: number): void
}>()

const findSection = (name: string) =>
  props.sections.find(s => s.name === name) ?? null

const editorChoiceSection = computed(() =>
  props.sections.find(s => s.id === 0 && s.name === 'Выбор редакции') ?? null,
)
const apkNewsSection = computed(() => findSection('Новости АПК'))
const careerSection = computed(() => findSection('Карьера'))
const educationSection = computed(() => findSection('Образование и наука'))
const posterSection = computed(() => findSection('Афиша и конкурсы'))
const lifehacksSection = computed(() => findSection('Лайфхаки'))
const digitalLectureSection = computed(() => findSection('Цифровой лекторий'))
</script>
